import * as availabilityObject from 'availability';
import moment from 'moment';
export var toTimeText = function (params) {
    var milliseconds = params.milliseconds;
    var basetext = params.basetext;
    var i18n = params.i18n;
    if (milliseconds == null) {
        return '';
    }
    var now = moment().valueOf();
    var time = milliseconds - now;
    time = Math.ceil(time / 60 / 1000);
    if (time > 60) {
        return '';
    }
    if (time > 1) {
        return i18n.get(basetext, { params: { minutes: time } });
    }
    return i18n.get(basetext + 'OneMinute');
};
export var getCombinedStatus = function (availability, time) {
    var when = time.valueOf() || Number.MAX_VALUE; // Has to be before the iterator since
    // the iterator changes cachedTime.valueOf()
    var _availability = availability || { weekly: [], exceptions: [] };
    var util = new availabilityObject.AvailabilityIterator({
        cal: time.clone(),
        availability: _availability || {},
    });
    if (!util.hasNext()) {
        return {
            available: { when: Number.MAX_VALUE },
            unavailable: { when: Number.MAX_VALUE },
        };
    }
    var ret = { available: {}, unavailable: {} };
    var nowStatus = util.next();
    ret[nowStatus.status].when = when;
    ret[nowStatus.status].until = nowStatus.until || Number.MAX_VALUE;
    ret[nowStatus.status].comment = nowStatus.comment;
    ret[nowStatus.status].reason = nowStatus.reason;
    when = nowStatus.until || Number.MAX_VALUE;
    if (!nowStatus.until) {
        return ret;
    }
    var nextStatus = util.next();
    while (nextStatus.status === nowStatus.status) {
        ret[nextStatus.status].until = nextStatus.until || Number.MAX_VALUE;
        when = nextStatus.until || Number.MAX_VALUE;
        if (!nextStatus.until) {
            return ret;
        }
        nextStatus = util.next();
    }
    ret[nextStatus.status].when = when;
    ret[nextStatus.status].until = nextStatus.until || Number.MAX_VALUE;
    ret[nextStatus.status].comment = nextStatus.comment;
    ret[nextStatus.status].reason = nextStatus.reason;
    // TODO, until not completely correct here, should go next until hitting the first...
    return ret;
};
export var getStatus = function (availability, time) {
    var statuses = getCombinedStatus(availability, time);
    var nextAvailable = statuses.available.when || Number.MAX_VALUE;
    var nextUnavailable = statuses.unavailable.when || Number.MAX_VALUE;
    if (nextAvailable < nextUnavailable) {
        return {
            status: 'available',
            until: nextUnavailable,
            reason: statuses.available.reason,
            comment: statuses.available.comment,
        };
    }
    else {
        return {
            status: 'unavailable',
            until: nextAvailable,
            reason: statuses.unavailable.reason,
            comment: statuses.unavailable.comment,
        };
    }
};
//# sourceMappingURL=statusLogic.js.map